import React, { useRef, useEffect } from 'react';
import '../stylesheets/Colors.css';
import { SketchPicker } from 'react-color';

function useClickOutside(ref, callback) {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);
}


function ColorPicker({ color, onChange, closePicker }) {
  const pickerRef = useRef(null);
  useClickOutside(pickerRef, closePicker);

  return (
    <div ref={pickerRef} style={{ position: 'absolute', zIndex: 10 }}>
      <SketchPicker color={color} onChange={onChange} />
    </div>
  );
}


class Color extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: 'default',
            showChildComponent: false,
        }

        this.handleClick = this.handleClick.bind(this); // Bind the method
    }

    update(event) {
        if (event.target.value.length > 7) event.target.value = event.target.value.slice(0, 6);
        if (!event.target.value.startsWith('#')) event.target.value = '#' + event.target.value;

        this.props.update(this.props.index, event.target.value);
    }

    handleClick() {
        this.setState({
            showChildComponent: !this.state.showChildComponent,
        });
    }
    
    render() {
        if (this.state.status === 'success' && !this.state.timeout) this.setState({ timeout: setTimeout(() => this.setState({ status: 'default', timeout: null }), 1500) });

        return (
            <div className="color-item" key={this.props.index} style={{ border: this.state.status === 'success' ? '3px solid var(--success-color)' : '3px solid transparent' }}>
                <div className="box">
                    <div className="color-preview" style={{ backgroundColor: this.props.color }}></div>
                    <input className="color-input" maxLength="7" placeholder="#000000" value={this.props.color} onChange={(event) => this.update(event)}></input>
                    
        

                    <div className="color-counter-container">
                        {this.state.showChildComponent && (
                            <ColorPicker
                                color={this.props.color}
                                onChange={(color) => {this.props.update(this.props.index, color.hex);}}
                                closePicker={() => this.setState({ showChildComponent: false })}
                            />
                        )}


                        <div className="color-counter" style={{ backgroundColor: this.state.status === 'success' ? 'var(--success-color)' : null }}>
                            <p className="color-counter-text">
                                {this.props.index + 1}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="color-button color-picker" onClick={this.handleClick} style={{marginRight:"auto"}}>
                        <svg id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="390.954px" height="390.955px" viewBox="0 0 390.954 390.955" style={{ enableBackground: "new 0 0 390.954 390.955", }} xmlSpace="preserve">
                            <g><g>
                                <path d="M377.314,27.704C360.761,0.494,325.283-8.145,298.076,8.41l-52.561,31.977l-3.607-5.932 c-10.484-17.229-32.947-22.7-50.179-12.218C174.5,32.72,169.032,55.184,179.512,72.415l7.162,11.771L60.314,161.652 c-11.612,7.065-30.483,32.364-35.989,39.95c-2.97,4.09-3.191,9.563-0.565,13.881l24.784,40.738 c2.627,4.317,7.591,6.637,12.587,5.88c9.269-1.402,40.41-6.529,52.024-13.596l126.357-77.467l7.161,11.771 c10.481,17.229,32.946,22.7,50.178,12.217c17.229-10.481,22.699-32.946,12.217-50.177l-3.607-5.93l52.561-31.978 C385.229,90.389,393.868,54.912,377.314,27.704z M100.124,227.084l-0.694-59.882l85.469-52.59 c0.715,8.641,3.392,17.25,8.204,25.161c4.812,7.911,11.229,14.245,18.571,18.853L100.124,227.084z" />
                                <path d="M52.666,276.584c-1.823-1.458-4.413-1.459-6.238-0.003C44.745,277.922,5.23,309.82,5.23,343.554 c0,27.909,18.223,47.4,44.314,47.4c26.836,0,46.314-19.936,46.314-47.4C95.859,311.472,54.43,277.995,52.666,276.584z  M55.582,378.402c-0.414,0.104-0.829,0.155-1.237,0.155c-2.231,0-4.266-1.506-4.842-3.769c-0.68-2.672,0.931-5.389,3.6-6.075 c0.915-0.241,20.916-5.754,20.913-25.823c0-2.762,2.237-5,4.999-5.001c2.762,0,5.001,2.238,5.001,4.999 C84.02,365.254,65.417,375.898,55.582,378.402z" />
                            </g></g>
                        </svg>
                </div>
                <div className="box">
                    {/* <div className="color-button">
                        <svg viewBox="0 0 21 22" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.0394 1.30996C18.5191 -0.380284 15.9041 -0.43783 14.3196 1.15472L11.532 3.94503L10.6005 3.01225L8.74432 4.86979L16.1811 12.3066L18.0373 10.4491L17.1045 9.51629L19.7329 6.88791C21.2452 5.37566 21.4727 2.89315 20.0407 1.30996H20.0394ZM2.30719 15.0273C2.00608 15.3271 1.76118 15.6697 1.57114 16.0498L0 19.1947L1.86021 21.0549L5.00516 19.4838C5.3839 19.2964 5.72784 19.0422 6.02895 18.7477L12.4634 12.3133L8.74833 8.59823L2.30719 15.026V15.0273Z" fill="white"/>
                        </svg>
                    </div> */}
                    
                    <div className="color-button" onClick={() => {
                        navigator.clipboard.writeText(this.props.color);
                        this.setState({ status: 'success' });
                    }}>
                        
                        <svg viewBox="0 0 24 27" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.1679 0.555557H2.77399C1.45455 0.555557 0.375 1.6351 0.375 2.95455V19.7475H2.77399V2.95455H17.1679V0.555557ZM20.7664 5.35354H7.57197C6.25253 5.35354 5.17298 6.43308 5.17298 7.75253V24.5455C5.17298 25.8649 6.25253 26.9444 7.57197 26.9444H20.7664C22.0859 26.9444 23.1654 25.8649 23.1654 24.5455V7.75253C23.1654 6.43308 22.0859 5.35354 20.7664 5.35354ZM20.7664 24.5455H7.57197V7.75253H20.7664V24.5455Z" />
                        </svg>
                    </div>
                    <div className="color-button" style={{ cursor: this.props.disabled.up ? 'not-allowed' : 'pointer' }} onClick={() => this.props.move(this.props.index, 'up')}>
                        <svg viewBox="0 0 22 15" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: '1.5px' }}>
                            <path d="M0.194431 11.3889L2.83332 14.0279L10.7501 6.11112L18.6667 14.0279L21.3055 11.3889L10.7501 0.833336L0.194431 11.3889Z" fill="white"/>
                        </svg>
                    </div>
                    <div className="color-button" style={{ cursor: this.props.disabled.down ? 'not-allowed' : 'pointer' }} onClick={() => this.props.move(this.props.index, 'down')}>
                        <svg viewBox="0 0 22 14" xmlns="http://www.w3.org/2000/svg" style={{ marginTop: '1.5px' }}>
                            <path d="M0.694439 3.11109L3.33332 0.472229L11.2501 8.38882L19.1667 0.472229L21.8055 3.11109L11.2501 13.6666L0.694439 3.11109Z" fill="white"/>
                        </svg>
                    </div>
                    <div className="color-button" style={{ cursor: this.props.disabled.remove ? 'not-allowed' : 'pointer' }} onClick={() => this.props.remove(this.props.index)}>
                        <svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 2.115L18.885 0L10.5 8.385L2.115 0L0 2.115L8.385 10.5L0 18.885L2.115 21L10.5 12.615L18.885 21L21 18.885L12.615 10.5L21 2.115Z" />
                        </svg>
                    </div>

                </div>
            </div>
        );
    }
}
export default Color;